import React, {useState} from 'react';
import {Box, Link, ListItemIcon, ListItemText, Menu, MenuItem, Typography} from '@material-ui/core';
import {NavLink} from "react-router-dom";
import {capitalize} from "../../../../helpers/utils";
import {ChipLabel} from "../../shared/Chips";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import LinkIcon from "@material-ui/icons/Link";
import PersonIcon from "@material-ui/icons/Person";
import WarningReasonIcon from "../../pwtWarnings/table/WarningReasonIcon";

const DuplicateTeamsWarning = ({warnings, team}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const teams = warnings.map(({id, extra_data: {teams}}) => teams).flat().filter((t) => !t.merged_at);;

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = (event) => {
        setAnchorEl(null);
    }

    return (
        <>
            {
                (team && warnings.length > 0 && teams.length > 0)  ? <>
                    <Box display={"flex"} gridColumnGap={"10px"} alignItems={"center"}>
                        <ChipLabel label={"Potential Duplicate Record Found"} className={"colored-element warning"} />
                        <Link
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleOpenMenu}
                        >
                            View Duplicates
                        </Link>
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleCloseMenu}
                        PaperProps={{
                            style: {
                                maxHeight: 40 * 4.5,
                            },
                        }}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        {teams.map(({id, name, crd_id=null, reasons}) => (
                            <MenuItem key={id}>
                                <ListItemText primary={
                                    <NavLink
                                        key={id}
                                        to={{
                                            pathname:`/admin/live_data/private_wealth_teams`,
                                            search: `?team_id=${id}`,
                                            state: {from: `/admin/live_data/private_wealth_teams`, fromSearch: `team_id=${team.id}`}
                                        }}
                                        onClick={handleCloseMenu}
                                    >
                                        {`${name} ${crd_id ? "(" + crd_id + ")" : ""}`}
                                    </NavLink>}
                                />
                                {
                                    reasons?.length > 0 ? <ListItemIcon style={{marginLeft: "10px"}}>
                                        {
                                            reasons.map((reason) => <WarningReasonIcon reason={reason} />)
                                        }
                                    </ListItemIcon> : null
                                }
                            </MenuItem>
                        ))}
                    </Menu>
                </> : null
            }
        </>
    )
}

export default DuplicateTeamsWarning;
